import Image from 'next/future/image';
import { getEdgeUrl } from '@/lib/getEdgeUrl';
import Leaders from './Leaders';

const Team = () => (
  <section className="bg-white">
    <div className="reebelo-container overflow-hidden">
      <div className="lg:overflow-hidden ">
        <div className="w-[247%] xs:w-[190%] sm:w-[160%] md:w-[125%] lg:w-[124%] xl:w-full">
          <Image
            src={getEdgeUrl('images/about-us/team/desktop.png')}
            alt="Team"
            width={3000}
            height={1000}
            className="h-auto w-full"
            quality={100}
          />
        </div>
      </div>
      <div className="mt-[-24vw] w-full xs:mt-[-19vw] xs:w-[72vw] sm:mt-[-15vw] sm:w-[57vw] md:mt-[-13vw] md:w-[48vw] lg:mt-[-130px] lg:w-[475px] xl:mt-[-135px] xl:w-[500px] 2xl:mt-[-145px] 2xl:w-[550px]">
        <h3 className="text-xl font-bold leading-tight md:text-2xl">
          Say hello to the Reebels
        </h3>
        <p className="mt-2">
          Busting myths about refurbs, holding the baton for sustainability, and
          of course, bringing you the best prices for your favorite products
          every day - meet the dream team behind Reebelo.
        </p>
      </div>
    </div>
    <Leaders />
  </section>
);

export default Team;
